// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9066 ? "dc112a36" : chunkId) + "." + {"6223":"1dd09663471dc882","9066":"f5928f3bab75bb2b"}[chunkId] + ".js";
};